const ALL = 'all';
const RECIRCULATION = 'recirculation';
const PITC = 'pitc';
const SPOTLIGHT = 'spotlight';
const REACTIONS = 'reactions';
const CONVERSATION = 'conversation';
const CONVERSATION_SDK = 'conversation-sdk';
const FEED = 'feed';
const PITC_AMP = 'recirculation_amp';
const PITC_DOUBLE_DECKER = 'pitc_dd';
const PITC_HOMEPAGE = 'pitc_hp';
const DISCOVER = 'discover';
const INDEPENDENT = 'independent_ad';
const INDEPENDENT_HP = 'independent_ad_hp';
const INDEPENDENT_SDK = 'independent_ad_sdk';
const DEFAULT = 'default';
const TOPIC_TRACKER = 'topic_tracker';

export {
  ALL,
  RECIRCULATION,
  REACTIONS,
  CONVERSATION,
  CONVERSATION_SDK,
  FEED,
  PITC,
  SPOTLIGHT,
  PITC_AMP,
  PITC_DOUBLE_DECKER,
  PITC_HOMEPAGE,
  DISCOVER,
  INDEPENDENT,
  INDEPENDENT_HP,
  INDEPENDENT_SDK,
  DEFAULT,
  TOPIC_TRACKER
};
